<template>
  <div class="instagram-analytics-public-header">
    <div class="custom-title" layout layout-align="start-center">
      <el-tooltip :content="campaign.account.name">
        <Icon
          class="mr-x1"
          :picture-url="campaign.account.pictureUrl"
          :name="campaign.account.name"
          :icon-type="campaign.targetSns"
        ></Icon>
      </el-tooltip>
      <div>{{ campaign.title }}</div>
    </div>
    <div class="mt-x1">
      期間: {{ formatDatetime(campaign.startDatetime) }} 〜 {{ formatDatetime(campaign.endDatetime) }}
    </div>
    <div v-if="isCampaignFinalCollection">
      <div class="mt-x1">
        <div class="message message-info">
          分析データの最終集計中です。<br />{{ collectCompletedAt }}
          ごろまでに最終的なデータが反映されます。応募件数により、反映が遅れる場合があります。
        </div>
      </div>
    </div>
    <div v-else-if="isCampaignCollectionCompleted">
      <div class="mt-x1">
        <div class="message message-info">分析データの最終集計が完了しました。</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment-timezone'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
import { CAMPAIGN_STATUS } from '@/client/constant'
import { formatDatetime } from '@/client/filters/filters'
import { useInstagramAnalyticsPublicStore } from '@/client/store/useInstagramAnalyticsPublicStore'

export default defineComponent({
  components: { Icon },
  computed: {
    ...mapState(useInstagramAnalyticsPublicStore, {
      campaign: function (state) {
        const campaign = { ...state.campaign }

        if (!campaign.account || !campaign.account.name) {
          campaign.account = {
            name: '削除されたアカウント',
            pictureUrl: require('@/client/assets/images/instagram_default_profile.png')
          }
        }

        return campaign
      }
    }),

    isCampaignFinalCollection() {
      return this.campaign.status === CAMPAIGN_STATUS.DURING_FINAL_COLLECTION
    },

    isCampaignCollectionCompleted() {
      return this.campaign.status === CAMPAIGN_STATUS.COLLECTION_COMPLETED
    },

    collectCompletedAt() {
      // 分析バッチの実行完了を考慮し、キャンペーン終了時刻の1時間後を表示する
      return moment(this.campaign.endDatetime).add(1, 'hours').format('YYYY年MM月DD日 HH:mm')
    }
  },
  methods: {
    formatDatetime
  }
})
</script>
